module.exports = __webpack_public_path__ + "img/Rutilio.98405c2d.png";